import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";
import Link from "next/link";
import styles from "./password_changed.module.scss";

export const PasswordChanged = () => {
  return (
    <section className={styles.section_auth}>
      <div className={styles.side_bg}></div>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.left_wrapper}>
            <div className={styles.logo_and_title_wrapper}>
              <Image
                src={getAssets("assets/logo-beta.webp")}
                alt="UniSearch Logo"
                blurDataURL={getAssets("assets/logo-beta.webp")}
                placeholder="blur"
                width={186}
                height={30}
              />
              <div className={styles.title}>
                Discover study abroad opportunities around the world with
                UniSearch
              </div>
            </div>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/illustration_singin.png")}
                alt="singin"
              />
            </div>
          </div>
          <div className={styles.right_wrapper}>
            <div className={styles.form_title_wrapper}>
              <div className={styles.form_title}>Password is changed</div>
              <div className={styles.form_sub_title}>
                Your password is successfully changed. Please Sign in to your
                account.
              </div>
            </div>

            <div className={styles.resend_text}>
              <Link legacyBehavior href="/signin">
                <a
                  className="btn btn-secondary btn-bg"
                  style={{ display: "inline-block" }}
                >
                  Sign In
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PasswordChanged;
